import React from 'react';
import LinkItem from 'components/common/Link';
import { Link } from 'react-router-dom';
import ROUTES from 'constants/routes';
import { getImageUrl } from 'helpers';





const AboutUsSectionItem = ({ data }) => {
    const { title, description, link_text, small_title, type, image } = data;

    const itemImage = getImageUrl(image);
    let itemStyle;
    if (type === "image") {
        itemStyle = { backgroundImage: `url("${itemImage}")`, };
    }

    return type === "image" ? (
        <div className={`aboutus-section-item aboutus-section-item__image`} style={itemStyle}></div>
    ) : (
        <>
            {type === "small" ? (
                <div className="aboutus-section-card">
                    <div className='aboutus-section-card__icon'><img src={itemImage} alt="" /></div>
                    <div className={`h2 ${small_title === "+" && "h2--center"}`}>
                        {title} {small_title && <span className='description2'>{small_title}</span>}
                    </div>
                    <div className='body2'>{description}</div>
                </div >

            ) : (
                <Link to={ROUTES.about_us} className={`aboutus-section-item`}>
                    <div className="body1"> {description}</div>
                    {link_text && <LinkItem text={link_text} />}
                </Link>
            )}
        </>
    );
};

export default AboutUsSectionItem;
